export type TipoProduto = 1 | 2 | 3 | 4;

export const TIPO_PRODUTO_LABEL: Record<TipoProduto, string> = {
  1: 'Default',
  2: 'TB3',
  3: 'Eagle Labs',
  4: 'Ship Offers',
};

export interface ClienteProdutoProdutorResumo {
  id: string;
  nome: string;
  sobrenome: string | null;
  email: string;
}

export interface ClienteProdutoListItem {
  id: string;
  nome: string;
  ativo: boolean;
  tipo: TipoProduto | null;
  tipoDescricao: string | null;
  preco: number | null;
  moeda: number | null;
  moedaSigla: string | null;
  recorrencia: boolean;
  categoria: number | null;
  categoriaDescricao: string | null;
  imagemProduto: string | null;
  createdAt: string;
  produtor: ClienteProdutoProdutorResumo | null;
}

export interface PaginatedClienteProdutos {
  data: ClienteProdutoListItem[];
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

export interface ClienteProdutoIdentificacao {
  nome: string;
  descricao: string | null;
  categoria: number | null;
  categoriaDescricao: string | null;
  idioma: number | null;
  idiomaDescricao: string | null;
  imagemProduto: string | null;
  sku: string | null;
  codigoTb3: string | null;
  cademiProdutoId: string | null;
  astromembersProdutoId: string | null;
}

export interface ClienteProdutoComercial {
  preco: number | null;
  moeda: number | null;
  moedaSigla: string | null;
  metodoPagamento: number[];
  metodoPagamentoDescricoes: string[];
  parcelamentoPagamento: number | null;
  parcelamentoDescricao: string | null;
  recorrencia: boolean;
  participaRecorrencia: boolean;
  garantiaProduto: number | null;
  garantiaDescricao: string | null;
  tipo: number | null;
  tipoDescricao: string | null;
  entregaProduto: number | null;
  entregaDescricao: string | null;
  kit: boolean;
  tempoCarrinhoAbandonado: string | null;
  unidadeMedidaCarrinhoAbandonado: number | null;
  purchaseNoPix: boolean;
}

export interface ClienteProdutoConteudo {
  paginaVendas: string | null;
  emailSuporte: string | null;
  nomeSuporte: string | null;
  invoiceDescription: string | null;
  obs: string | null;
}

export interface ClienteProdutoAfiliados {
  habilitaAfiliados: boolean;
  validarAfiliadoManualmente: boolean;
  comissaoAfiliado: number | null;
  habilitaCupom: boolean;
}

export interface ClienteProdutoIntegracoes {
  facebookPixel: string | null;
  facebookToken: string | null;
  tikTokPixel: string | null;
  tikTokToken: string | null;
  vTurbAccountId: string | null;
  vTurbVideoId: string | null;
  vTurbEnabled: boolean;
  vTurbForwardEvents: boolean;
}

export interface ClienteProdutoRelacaoOferta {
  id: string;
  nome: string | null;
  preco: number | null;
  ativo: boolean | null;
}

export interface ClienteProdutoRelacaoCupom {
  id: string;
  codigo: string | null;
  tipo: number | null;
  desconto: number | null;
  ativo: boolean | null;
}

export interface ClienteProdutoRelacaoLink {
  id: string;
  tipo: number | null;
  descricao: string | null;
  ativo: boolean | null;
}

export interface ClienteProdutoRelacaoKit {
  id: string;
  produtoId: string | null;
  quantidade: number | null;
}

export interface ClienteProdutoTotais {
  ofertas: number;
  cupons: number;
  links: number;
  componentesKit: number;
  planos: number;
}

export interface ClienteProdutoDetail {
  id: string;
  createdAt: string;
  produtor: ClienteProdutoProdutorResumo & {
    tipoPessoa: 'PF' | 'PJ' | null;
    documento: string | null;
  };
  identificacao: ClienteProdutoIdentificacao;
  comercial: ClienteProdutoComercial;
  conteudo: ClienteProdutoConteudo;
  afiliados: ClienteProdutoAfiliados;
  integracoes: ClienteProdutoIntegracoes;
  ativo: boolean;
  sendOnlyCommission: boolean;
  ofertas: ClienteProdutoRelacaoOferta[];
  cupons: ClienteProdutoRelacaoCupom[];
  links: ClienteProdutoRelacaoLink[];
  componentesDoKit: ClienteProdutoRelacaoKit[];
  totais: ClienteProdutoTotais;
  payloadTecnico: Record<string, unknown>;
}

export interface ClienteProdutosFilters {
  search?: string;
  ativo?: boolean | '';
  tipo?: TipoProduto | '';
  recorrencia?: boolean | '';
}

export type ClienteProdutosFiltersInput = Partial<ClienteProdutosFilters>;
